export default __webpack_public_path__ + "static/media/event-Phoenix.afc49fab.jpg";